import {
  AlertInformationIcon,
  AlertWarningIcon,
  BuildingFilledIcon,
  CheckmarkCircleIcon,
  ChevronDownIcon,
  MoreHorizontalIcon,
  PeopleFilledIcon,
  PersonAvatarIcon,
  XCircleIcon,
  XIcon,
} from '@adsk/alloy-react-icon';

import AlloyProgressRing from './alloy/AlloyProgressRing';
import { ComponentIcons } from './types';

export const alloyComponentIcons: ComponentIcons = {
  accordion: {
    expandIcon: ChevronDownIcon,
  },
  avatar: {
    defaultIcon: PersonAvatarIcon,
    companyIcon: BuildingFilledIcon,
    roleIcon: PeopleFilledIcon,
  },
  progressRing: AlloyProgressRing,
  breadcrumbs: {
    pileIcon: MoreHorizontalIcon,
    pileIconHighDensity: MoreHorizontalIcon,
  },
  notification: {
    closeIcon: XIcon,
    infoIcon: AlertInformationIcon,
    successIcon: CheckmarkCircleIcon,
    warningIcon: AlertWarningIcon,
    errorIcon: XCircleIcon,
  },
};
